import React from 'react';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import { Checkbox } from '../../../../../app/form/checkbox/checkbox';
import { routes } from '../../../../../../config/routes';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { cn } from '../../../../../../utils/tailwind';

interface AgreeTermsProps {
    handleChange?: (e: React.ChangeEvent<never>) => void;
}

export const AgreeTerms: React.FC<AgreeTermsProps> = observer(({ handleChange }) => {
    const {
        authStore: { authDialogStore },
    } = useRootStore();

    const onChange = () => {
        authDialogStore.switchAgreedTerms();

        if (handleChange) {
            handleChange({
                target: {
                    name: 'agreedTerms',
                    value: authDialogStore.agreedTerms,
                },
            } as React.ChangeEvent<never>);
        }
    };

    return (
        <div
            className={cn(
                'inline-flex rounded-small py-[0.8rem] pl-[1.8rem] [&_label_.MuiCheckbox-root]:-m-[0.9rem] [&_label_.MuiCheckbox-root]:mr-0',
                authDialogStore.agreedTerms ? 'bg-status-positive/30' : 'bg-status-warning/20',
            )}
        >
            <Checkbox
                name="agreedTerms"
                checked={authDialogStore.agreedTerms}
                onChange={onChange}
                label={
                    <Trans
                        i18nKey={'layout.forms.common.agreeTerms'}
                        components={{
                            terms: (
                                <a href={routes.web.termsAndConditions} target={'_blank'} rel="noreferrer">
                                    Link
                                </a>
                            ),
                            privacy: (
                                <a href={routes.web.privacyPolicy} target={'_blank'} rel="noreferrer">
                                    Link
                                </a>
                            ),
                        }}
                    />
                }
            />
        </div>
    );
});
